import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './uspBlock.css'

export class USPBlock extends Component {
  render () {
    return (
      <div className={styles.container}>
        <h4 className={styles.heading}>
          {this.props.title}
        </h4>
        <p className={styles.text}>
          {this.props.children}
        </p>
      </div>

    )
  }
}

USPBlock.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
}

export default USPBlock
